import React from 'react'
import Logo from '../../assets/images/logo.svg'

const Header = () => (
  <header>
    <img src={Logo} height="40" alt="Quick Sprout Logo"/>
    <nav>
      <a href="/blog">Blog</a>
      <a href="/university">University</a>
      <a href="/contact">Contact</a>
    </nav>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/homepage/header.js